module.exports = "<jb-header></jb-header>\n\n<div class=\"checkout-wrapper\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-7 col-sm-10 ml-auto mr-auto\">\n        <div class=\"tab-content\">\n          <ui-view name=\"content\"></ui-view>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<jb-footer></jb-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/checkout/checkout.component.html
// module id = mpIJ
// module chunks = 0